import { render } from "./UserProfileTabs.vue.js?vue&type=template&id=819a0aca!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserProfileTabs.vue?vue&type=template&id=819a0aca"
import script from "./UserProfileTabs.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserProfileTabs.vue?vue&type=script&lang=js"
export * from "./UserProfileTabs.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserProfileTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/user-profile-page/UserProfileTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "819a0aca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('819a0aca', __exports__)) {
    api.reload('819a0aca', __exports__)
  }
  
  module.hot.accept("./UserProfileTabs.vue.js?vue&type=template&id=819a0aca!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UserProfileTabs.vue?vue&type=template&id=819a0aca", () => {
    api.rerender('819a0aca', render)
  })

}


export default __exports__